import { Card } from './Card';  // Assuming Card is in a separate file

export class HandEvaluationResult {
    rank: string;
    cards: Card[];

    constructor(rank: string, cards: Card[]) {
        this.rank = rank;
        this.cards = cards;
    }
}
export class HandEvaluator {

    // Hand rankings enum
    static HandRank = {
        HighCard: 'High Card',
        OnePair: 'One Pair',
        TwoPair: 'Two Pair',
        ThreeOfAKind: 'Three of a Kind',
        Straight: 'Straight',
        Flush: 'Flush',
        FullHouse: 'Full House',
        FourOfAKind: 'Four of a Kind',
        StraightFlush: 'Straight Flush',
        RoyalFlush: 'Royal Flush'
    };
  

    // Evaluates the player's hand and returns the result
    static evaluateHand(playerHand: Card[], communityCards: Card[]): any {
        let allCards: Card[] = [...playerHand, ...communityCards];

        let result: Card[] = [];
        // Sort by rank descending
        allCards.sort((a, b) => b.cardRank - a.cardRank);

        console.log(allCards)
        
        if (this.isRoyalFlush(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.RoyalFlush, result);
        }

        else if (this.isStraightFlush(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.StraightFlush, result);
        }

        else if (this.isFourOfAKind(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.FourOfAKind, result);
        }

        else if (this.isFullHouse(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.FullHouse, result);
        }

        else if (this.isFlush(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.Flush, result);
        }

        if (this.isStraight(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.Straight, result);
        }

        else if (this.isThreeOfAKind(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.ThreeOfAKind, result);
        }

        else if (this.isTwoPair(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.TwoPair, result);
        }

        else if (this.isOnePair(allCards, result)) {
            return new HandEvaluationResult(this.HandRank.OnePair, result);
        }

        // High Card
        else{
            return new HandEvaluationResult(this.HandRank.HighCard, allCards.slice(0, 5));
        }
    }

    private static isRoyalFlush(cards: Card[], result: Card[]): boolean {
        // if (this.isStraightFlush(cards, result) && result[0].cardRank === Card.Rank.Ace) {
        //     return true;
        // }
        // result.length = 0; // Clear result
        // return false;

        if (this.isStraightFlush(cards, result) && result[0].cardRank === Card.Rank.Ace) {
            return true;
        }
        result.length = 0; // Clear result
        return false;
    }

    private static isStraightFlush(cards: Card[], result: Card[]): boolean {
        // if (this.isFlush(cards, result) && this.isStraight(result, result)) {
        //     return true;
        // }
        // result.length = 0; // Clear result
        // return false;

        if (this.isFlush(cards, result) && this.isStraight(result, result)) {
            return true;
        }
        result.length = 0; // Clear result
        return false;
    }

    private static isFourOfAKind(cards: Card[], result: Card[]): boolean {
        // const groups = this.getGroups(cards, 4);
        // if (groups.length) {
        //     result.push(...groups[0], ...cards.filter(c => !groups[0].includes(c)).slice(0, 1));
        //     return true;
        // }
        // return false;

        const groups = this.getGroups(cards, 4);
        if (groups.length) {
            result.push(...groups[0]);
            const kickers = cards.filter(c => !groups[0].includes(c)).sort((a, b) => b.cardRank - a.cardRank);
            result.push(...kickers.slice(0, 1)); // Add top kicker
            return true;
        }
        return false;
    }

    private static isFullHouse(cards: Card[], result: Card[]): boolean {
        // const threeGroups = this.getGroups(cards, 3);
        // const pairGroups = this.getGroups(cards, 2);

        // if (threeGroups.length && pairGroups.length) {
        //     result.push(...threeGroups[0], ...pairGroups[0]);
        //     return true;
        // }
        // return false;
        const threeGroups = this.getGroups(cards, 3);
        const pairGroups = this.getGroups(cards, 2);

        if (threeGroups.length && pairGroups.length) {
            result.push(...threeGroups[0]);
            const remainingPairs = pairGroups.filter(pair => pair[0].cardRank !== threeGroups[0][0].cardRank);
            if (remainingPairs.length) {
                result.push(...remainingPairs[0]); // Add the highest pair
            }
            return true;
        }
        return false;
    }

    private static isFlush(cards: Card[], result: Card[]): boolean {
        // const suitGroups = cards.reduce((acc, card) => {
        //     acc[card.cardSuit] = acc[card.cardSuit] || [];
        //     acc[card.cardSuit].push(card);
        //     return acc;
        // }, {} as Record<string, Card[]>);

        // for (const group of Object.values(suitGroups)) {
        //     if (group.length >= 5) {
        //         result.push(...group.slice(0, 5));
        //         return true;
        //     }
        // }
        // return false;
        const suitGroups = cards.reduce((acc, card) => {
            acc[card.cardSuit] = acc[card.cardSuit] || [];
            acc[card.cardSuit].push(card);
            return acc;
        }, {} as Record<string, Card[]>);

        for (const group of Object.values(suitGroups)) {
            if (group.length >= 5) {
                result.push(...group.sort((a, b) => b.cardRank - a.cardRank).slice(0, 5));
                return true;
            }
        }
        return false;
    }

    private static isStraight(cards: Card[], result: Card[]): boolean {
        // const distinctRanks = Array.from(new Set(cards.map(card => card.cardRank))).sort((a, b) => b - a);

        // for (let i = 0; i <= distinctRanks.length - 5; i++) {
        //     if (distinctRanks[i] - distinctRanks[i + 4] === 4) {
        //         result.push(...cards.filter(card => distinctRanks.slice(i, i + 5).includes(card.cardRank)));
        //         return true;
        //     }
        // }

        // // Ace-low straight
        // const aceLow = [Card.Rank.Ace, Card.Rank.Two, Card.Rank.Three, Card.Rank.Four, Card.Rank.Five];
        // if (aceLow.every(rank => distinctRanks.includes(rank))) {
        //     result.push(...cards.filter(card => aceLow.includes(card.cardRank)));
        //     return true;
        // }

        // return false;
        const distinctRanks = Array.from(new Set(cards.map(card => card.cardRank))).sort((a, b) => b - a);

        for (let i = 0; i <= distinctRanks.length - 5; i++) {
            if (distinctRanks[i] - distinctRanks[i + 4] === 4) {
                result.push(...cards.filter(card => distinctRanks.slice(i, i + 5).includes(card.cardRank)));
                return true;
            }
        }

        // Ace-low straight
        const aceLow = [Card.Rank.Ace, Card.Rank.Two, Card.Rank.Three, Card.Rank.Four, Card.Rank.Five];
        if (aceLow.every(rank => distinctRanks.includes(rank))) {
            result.push(...cards.filter(card => aceLow.includes(card.cardRank)));
            return true;
        }

        return false;
    }

    private static isThreeOfAKind(cards: Card[], result: Card[]): boolean {
        // const groups = this.getGroups(cards, 3);
        // if (groups.length) {
        //     result.push(...groups[0], ...cards.filter(c => !groups[0].includes(c)).slice(0, 2));
        //     return true;
        // }
        // return false;
        const groups = this.getGroups(cards, 3);
        if (groups.length) {
            result.push(...groups[0]);
            const kickers = cards.filter(c => !groups[0].includes(c)).sort((a, b) => b.cardRank - a.cardRank);
            result.push(...kickers.slice(0, 2)); // Add top 2 kickers
            return true;
        }
        return false;
    }

    private static isTwoPair(cards: Card[], result: Card[]): boolean {
        // const groups = this.getGroups(cards, 2);
        // if (groups.length >= 2) {
        //     result.push(...groups[0], ...groups[1], ...cards.filter(c => !groups.flat().includes(c)).slice(0, 1));
        //     return true;
        // }
        // return false;

        const groups = this.getGroups(cards, 2); // Get all pairs
    if (groups.length >= 2) {
        // Sort pairs by rank descending
        groups.sort((a, b) => b[0].cardRank - a[0].cardRank);

        // Add the two highest pairs
        result.push(...groups[0], ...groups[1]);

        // Add the highest kicker
        const remainingCards = cards.filter(c => !groups[0].includes(c) && !groups[1].includes(c));
        remainingCards.sort((a, b) => b.cardRank - a.cardRank);
        result.push(remainingCards[0]);

        return true;
    }
    return false;
    }

    private static isOnePair(cards: Card[], result: Card[]): boolean {
        // const groups = this.getGroups(cards, 2);
        // if (groups.length) {
        //     result.push(...groups[0], ...cards.filter(c => !groups[0].includes(c)).slice(0, 3));
        //     return true;
        // }
        // return false;
        const groups = this.getGroups(cards, 2); // Get all pairs
    if (groups.length) {
        // Sort pairs by rank descending
        groups.sort((a, b) => b[0].cardRank - a[0].cardRank);

        // Add the highest pair
        result.push(...groups[0]);

        // Add the three highest kickers
        const remainingCards = cards.filter(c => !groups[0].includes(c));
        remainingCards.sort((a, b) => b.cardRank - a.cardRank);
        result.push(...remainingCards.slice(0, 3));

        return true;
    }
    return false;
    }
    private static getGroups(cards: Card[], count: number): Card[][] {
        return Object.values(
            cards.reduce((acc, card) => {
                acc[card.cardRank] = acc[card.cardRank] || [];
                acc[card.cardRank].push(card);
                return acc;
            }, {} as Record<number, Card[]>)
        ).filter(group => group.length === count);
    }

    // Utility function to group cards by rank and return those that match the specified count
    private static getCardGroups(cards: Card[], count: number): Card[] {
        let groups = cards.reduce((acc: any, card) => {
            acc[card.cardRank] = (acc[card.cardRank] || []).concat(card);
            return acc;
        }, {});
    
        // Use Object.keys and reduce to flatten the array manually
        return Object.keys(groups)
            .map(key => groups[key])
            .filter((group: Card[]) => group.length === count)
            .reduce((acc: Card[], group: Card[]) => acc.concat(group), []);
    }
}
